import { graphql } from "react-relay";
import { EventSchedulerSuggestedRoom } from "@components/event-scheduler-suggested-room";

export const eventSchedulerRoomInputFragments = {
  workingGroup: graphql`
    fragment EventSchedulerRoomInput_workingGroup on WorkingGroup {
      rooms {
        ...EventSchedulerSuggestedRoom_room
        roomId
        name
        orgId
        estimatedCapacity
        reportedCapacity
        locationId
      }
    }
  `,
  schedulingResponseErrorable: graphql`
    fragment EventSchedulerRoomInput_schedulingResponseErrorable on SchedulingResponseErrorable {
      __typename
      ... on SchedulingResponse {
        uncrawledCalendars
        slots {
          summary {
            availableRooms
            freeAttendees
            inconvenientForAttendees
            focusTimeMinutesCost
            conflictingAttendees
          }
          attendanceImpacts {
            calendarId
            inconveniences
            hasConflict
            focusTimeMinutesCost
            conflictingMeetings
          }
          roomImpacts {
            roomId
            available
          }
          timeRange {
            id
            startTime {
              type
              dateOrDateTime
              timeZone
              offsetMinutes
              millis
            }
            endTime {
              type
              dateOrDateTime
              timeZone
              offsetMinutes
              millis
            }
          }
        }
      }
      ... on GraphEntityError {
        message
        statusCode
        body
      }
    }
  `,
};
